import React from 'react';
import ReactDOM from 'react-dom';
import './sass/style.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { initializeHotjar } from './services/external/hotjar';

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

serviceWorker.unregister();
initializeHotjar();
